// import moment from "moment";
// import { useEffect } from "react";

const TaxTableTeeTime = (props) => {
    const { fees } = props;
    // const { bookSheet, bookingUserList, currentDate, greenFeeMaster, onTaxCalculated, discountPercentage } = props;

    // useEffect(() => {
    //     if (onTaxCalculated) {
    //         onTaxCalculated(fees);
    //     }
    // }, [bookingUserList, greenFeeMaster, bookSheet.Hole, currentDate, bookSheet.Discount]);

    // return 'Y if weekend else 'N'
    // const isWeekend = () => {
    //     const day = moment(currentDate, 'DD-MM-YYYY').day();
    //     return day === 0 || day === 6 ? 'Y' : 'N';
    // };

    // const calculateGreenFee = () => {
    //     const weekend   = isWeekend();
    //     const hole      = parseInt(bookSheet?.Hole);
        
    //     let totalGreenFee  = 0;
    //     let totalCart      = 0;
    //     // let totalCaddy     = 0;
    //     let totalTax       = 0;
    //     let discountAmount = 0;
    //     let cartCount      = 0;
    //     // let caddyCount     = 0;

    //     bookingUserList.forEach(user => {
    //         const feeRecord = greenFeeMaster.find(fee =>
    //             fee.SubCategoryID === user.SubCategoryID && fee.Hole === hole && fee.IsWeekend === weekend
    //         );

    //         // console.log('feeRecord :- ', feeRecord);
    //         if (!feeRecord) return;

    //         totalGreenFee += feeRecord.GreenFee;

    //         if (user.IsCartRequired === "Y") {
    //             totalCart += feeRecord.Cart;
    //             cartCount++;
    //         }

    //         if (feeRecord?.GreenFee > 0 || user?.IsCartRequired === "Y") {
    //             const chargeableAmount = feeRecord?.GreenFee + (user.IsCartRequired === 'Y' ? feeRecord?.Cart : 0);
    //             totalTax += chargeableAmount * 0.18;
    //         }

    //         // if (user.IsCaddyRequired === "Y") {
    //         //     totalCaddy += feeRecord.Caddy;
    //         //     caddyCount++;
    //         // }
    //     });
        
    //     // applying discount test
    //     let discountPercent = discountPercentage ?? parseFloat(bookSheet.Discount);
    //     if (isNaN(discountPercent)) discountPercent = 0;
    //     const total = totalGreenFee + totalCart + totalTax;
    //     // const total = totalGreenFee + totalCart + totalCaddy + totalTax; // total including caddy -- old logic
    //     discountAmount = (total * discountPercent) / 100;

    //     const finalTotal = total - discountAmount;

    //     return {
    //         greenFee: totalGreenFee,
    //         cart: totalCart,
    //         // caddy: totalCaddy,
    //         tax: totalTax,
    //         discount: discountAmount,
    //         total: finalTotal,
    //         cartCount,
    //         // caddyCount
    //     };
    // };
    // const fees = calculateGreenFee();

    return (
        <>
            <table className="table table-bordered table-hover margin-b30">
                <thead className="light-grey-background">
                    <tr>
                        <th>Description</th>
                        <th className="text-right">Amount (₹)</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Green Fee</td>
                        <td className="text-right">₹  {fees.greenFee.toFixed(2)}</td>
                    </tr>
                    <tr>
                        <td>{fees.cartCount} Cart</td>
                        <td className="text-right">₹  {fees.cart.toFixed(2)}</td>
                    </tr>
                    <tr>
                        <td>{fees.caddyCount} Caddy</td>
                        <td className="text-right">₹  {fees.caddy.toFixed(2)}</td>
                    </tr>
                    {fees.discount > 0 && (
                        <tr>
                            <td>Discount</td>
                            <td className="text-right">- ₹  {fees.discount.toFixed(2)}</td>
                        </tr>
                    )}
                    <tr>
                        <td>SGST (9%)</td>
                        <td className="text-right">₹  {(fees.tax / 2).toFixed(2)}</td>
                    </tr>
                    <tr>
                        <td>CGST (9%)</td>
                        <td className="text-right">₹  {(fees.tax / 2).toFixed(2)}</td>
                    </tr>
                    <tr>
                        <td><strong>Total</strong></td>
                        <td className="text-right"><strong>₹  {fees.total.toFixed(2)}</strong></td>
                    </tr>
                </tbody>
            </table>
        </>
    );
};

export default TaxTableTeeTime;